import { render, staticRenderFns } from "./inner-act-items.vue?vue&type=template&id=65bde958&"
import script from "./inner-act-items.vue?vue&type=script&lang=js&"
export * from "./inner-act-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports